<template>
  <div>
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img">
          <!--img src="/img/homenavlogo.png" alt="" /-->
          <p style="font-size: 32px;line-height: 44px;margin: 0;">{{$t("my.title")}}</p>
        </div>
        <div style="display: flex; align-items: center;" v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>
      </div>
    </div>
    <!-- banner -->
    <div style="height: 220px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="banner_img" :src="$apiUrl + v.url" width="100%" height="220px">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 公告 -->
    <div style="padding: 8px; background: rgb(243, 243, 245);">
      <van-notice-bar
        class="notice-swiper"
        color="rgb(62, 30, 136)"
        background="#fff"
        scrollable
        :text="this.notice"
      >
        <template #left-icon>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAkCAYAAAD2IghRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC60lEQVRYhdXYXahUVRQH8N/dXft4CBLKS4QgPWReEx81UXtIoxAiKTJIMX0tjdCLkGZZBCqXKIIgEgtKCQIhiqLSlz6M9CEI4oaUglIvUSiIqNQ5Paw5cBzHO2fmnmnm/mGYs9dea+//2WfvtdZeQ2Prf5XkhvKs8Z9LMinPDcmlPJ6T7Iq+1NCP/queZ6U8G0t5tirJ85Rnh1KevdBavxizmLMsC53gUeaQG1Y/nsEruKUkG8W9WFHXJKmugbAY3+BNV5IucL+pEV+G24tGHcRvxhv4Hkvb6I52Mf5KHMXX+BkLmTrxtZjA5or6/3Qw9nx8hC/FNoOZ4kW63uNLsR0PdmiXVdC5DTu0XozDeJ/WxEdxD0aQN37/4ibMxhIs6pBwFQxjK7a5+oycwIv4sKxcYCHG1XjyO8B67MSdTfLzeBV7NX2tgvgKfNVrdtfAOLa0kL8lSP/RymhYeIXPe8erLR5van+MXfhxMqMkDkEvAlFVPIqf8AMexiPakCYIP9RTWu1xXMM3d4KE6+vn0nsk4eqmHZLw09MOdSZZ/yv66U3K2IgFFXUvYN8gEH8Wr3dos3EQtsqtXdiMDMKK7xFnrcjVJ8sgZ+Ac3h4E4udFitwRBmGrdIVpTfy6fpPoBgmX+k2iGySc6jOHO0QOfkiUOCoh4WCvGFXEeyIPXy1KHPsxp51Rwhf4pIfE2uFEU3uDKHm8hBuuZVR4lcdEFaofeBpj+Ksku1Hc6n/BU62MCuKXsVy85e+9YjgJxnEXXmuSz8G7+A4PlDuaI+cu7BYFn9nizYsQnIkXHcFcPKFeV/q3uO3vE6u9ptS3RGzpA+ILnWsV8i/hSIWJduI5UZ2tiqEKOhNiUd5pzLG81PckTuP5qUTOk9gkqlqHK9p0cr89gvsE2YmS/Cj1hPxjohC5TvuYcKaL8Q+KzHGtKDV/Sr25yge4Gy9rfQH/DZ9NYfwD+LZo1J1kXRYHa15jorP4U6zaMlysa6L/AAjlvYZkAVJOAAAAAElFTkSuQmCC"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>
    <!-- 游戏列表 -->
    <div class="hot-game">
        <div class="hot-title-div">
          <div>
            <span>{{$t("index.task")}}</span></div>
          <!--div @click="gotoMenu('/Game')">
            <span>查看更多</span>
            <van-icon name="arrow" color="#979799" />
          </div-->
        </div>
        <div class="hot-items-div">
          <van-grid :border = false :column-num="4" :icon-size="20">
            <van-grid-item @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
              <van-image class="game_item_img" :src="$apiUrl + v.ico">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <span>{{v.name}}</span>
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    <div>

      <!--van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="hot-recommend">
          <div class="hot-title-div">
            <div>
              <span>人气排行</span></div>
            <div>
              <span @click="gotoMenu('/Video')">查看更多</span>
              <van-icon name="arrow" color="#979799" />
            </div>
          </div>
          <div class="movie_list_0">
            <swiper class="movie_swiper" :options="movielistSwiperOption">
              <swiper-slide v-for="(v,key) in movielist_0" :key="key" >
                <van-image class="movie_cover" @click="toPlayVideo(v.id)"  round :src="v.cover">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>
                <img class="hot" v-if="key === 0" src="/img/home/no1.png">
                <img class="hot" v-if="key === 1" src="/img/home/no2.png">
                <img class="hot" v-if="key === 2" src="/img/home/no3.png">
                <div class="movie-list-item-bottom">
                  <div class="movie-time-div">
                    <span>{{v.title}}</span>
                    <div class="van-count-down">{{v.time}}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="hot-title-div">
            <div>
              <span>热门推荐</span></div>
            <div @click="gotoMenu('/Video')">
              <span>查看更多</span>
              <van-icon name="arrow" color="#979799" />
            </div>
          </div>
          <div class="movie_list_1">
            <div class="movie-list-item" v-for="(v,key) in movielist_1" :key="key" @click="toPlayVideo(v.id)">
              <van-image class="cover_img"  round :src="v.cover">
                <template v-slot:loading>
                  <van-loading type="circular"/>
                </template>
              </van-image>
              <div class="movie-list-item-bottom">
                <div class="movie-time-div">
                  <span>{{v.title}}</span>
                  <span>播放:{{v.count}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh-->

      <van-tabs @change="onChange" v-model="active">
        <van-tab :title="item.name" :name="item.id" title-style="font-size:16px;line-height:50px;" v-for="item in videolitem" :key="item.id">
          <div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list
                v-model="loading"
                :finished="finished"
                loading-text="Loading..."
                @load="onLoad"
              >
                <div class="list-item">
                  <div
                    class="movie-list-item"
                    v-for="(i, key) in data"
                    :key="key"
                    @click="toPlayVideo(i.id)"
                  >
                    <div
                      class="cover_img van-image van-image--round"
                      style="width: 100%; height: 100px;"
                    >
                      <img :src="i.vod_pic" class="van-image__img" />
                    </div>
                    <div class="movie-list-item-bottom">
                      <div class="movie-time-div">
                        <span>{{ i.vod_name }}</span>
                        <span style="font-size: 12px;">{{$t("video.play")}} :{{ i.count }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 1,
      id: 888,
      banners: [{}],
      notice: this.$t("index.loading"),
      hasToken: false,
      gameitem: [{}, {}, {}, {}], // 新增 gameitem
      basicData: [], // 新增 basicData
      movielist_0: [{}, {}, {}, {}], // 新增 movielist_0
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}], // 新增 movielist_1
      isLoading: false, // 新增 isLoading
      movielistSwiperOption: { // 新增 movielistSwiperOption
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  methods: {
    onLoad(isRefresh = false) {
      if (isRefresh) {
        this.page = 1;
        this.data = [];
      }
      this.loading = true;
      this.getVideoList().then(() => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
          Toast("刷新成功");
        }
        
      });
    },
    onChange(name) {
      this.id = name;
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.data = [];
      this.onLoad(true);
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig(); // 调用新增的 getBasicConfig 方法
        this.isLoading = false;
        Toast("刷新成功");
      }, 500);
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: `/PlayVideo?id=${id}` });
      }
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    gotoMenu(router) {
      this.$router.replace(router); // 替换为 replace
    },
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: `/Lottery?key=${key}&id=${id}` });
      }
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        console.log("sys_config",res)
        this.basicData = res.data;
        this.getNotice(this.basicData); // 获取公告
        this.getBanner(this.basicData); // 获取 banner
        this.getGameItem(); // 获取首页游戏列表
        this.getMovieList_0(this.basicData); // 获取首页视频0
        this.getMovieList_1(this.basicData); // 获取首页视频1
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      console.log('getGameItem')
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log('getGameItem ok',res)
        this.gameitem = res.data;
        const lang = localStorage.getItem("lang");
        this.gameitem.forEach((item) => {
          const parts = item.name.split(",");
          switch(lang){
            case 'kr':
              item.name = parts[0];
              item.ico = item.ico_kr??item.ico;
              break;
            case 'ja':
              item.name = parts[2];
              item.ico = item.ico_ja??item.ico;
              break;
            case 'en':
              item.name = parts[1]
              item.ico = item.ico_en??item.ico;
              break; 
            case 'zh':
              item.name = parts[3]
              item.ico = item.ico_zh??item.ico;
              break;               
            default:
              item.name = parts[1]
          }
        });
      });
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0.slice(0,4);
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1.slice(0,4);
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    getVideoList() {
      return this.$http({
        method: "get",
        data: { id: this.id, page: this.page },
        url: "video_list",
      }).then((res) => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          let data = res.data.data;
          console.log('getVideoList',data)
          const lang = localStorage.getItem("lang");
          data.forEach((item) => {
            const parts = item.vod_name.split(",");
            switch(lang){
              case 'kr':
                item.vod_name = parts[0];
                break;
              case 'ja':
                item.vod_name = parts[2]??parts[1];
                break;
              case 'en':
                item.vod_name = parts[1]??parts[1]
                break; 
              case 'zh':
                item.vod_name = parts[3]??parts[1]
                break;               
              default:
                item.vod_name = parts[1]
            }
          });
          this.data = this.data.concat(data);
          this.page++;
        } else {
          this.finished = true;
        }
      });
    },
    getVideoClass() {
      this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        const lang = localStorage.getItem("lang");
        this.videolitem = res.data;
        const obj = { id: 888, name: "인기 추천,Popular,ホットなおすすめ,热门推荐" };
        this.videolitem.unshift(obj);
        this.videolitem.forEach((item) => {
          const parts = item.name.split(",");
          switch(lang){
            case 'kr':
              item.name = parts[0]
              break;
            case 'ja':
              item.name = parts[2]
              break;
            case 'en':
              item.name = parts[1]
              break; 
            case 'zh':
            item.name = parts[3]
            break; 
            default:
              item.name = parts[1]
          }
        });

        this.active = this.id;
      });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },
  },
  created() {
    this.checkToken();
    const lang = localStorage.getItem("lang");
    switch(lang){
      case 'kr':
        this.id = 1;
        break;
      case 'ja':
        this.id = 5;
        break;
      case 'en':
        this.id = 8;
        break; 
      default:
        this.id = 888;
    }
    this.getVideoClass();
    this.getBasicConfig();
  },
};
</script>

<style scoped lang="less">
.header {
  height: 13vw;
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.movie-list-item {
  width: calc(50% - 16px);
  margin-bottom: 12px;
}
.cover_img {
  border-radius: 0;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px; 
}
.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 8px !important;
}
.movie-time-div {
  background-color: rgba(0, 0, 0, 0.4);
  height: 8vw;
  color: #fff;
  border-radius: 0 0 18px 18px;
  padding: 0 6px;
}
.movie-list-item-bottom div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 24vw;
  padding-left: 16px;
  font-size: 3vw;
}

.hot-game {
  margin: 20px 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.hot-title-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;

  span {
    padding-left: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  .van-icon {
    margin-left: 5px;
  }
}

.hot-items-div {
  margin-top: 10px;

  .van-grid-item {
    text-align: center;

    span {
      display: block;
      margin-top: 5px;
      font-size: 22px;
      color: #666;
    }
  }
}

.game_item_img {
  width: 95%;
  height: 60%;
  border-radius: 8px;
  overflow: hidden;
}





.hot-recommend{
  width: 100%;
  flex: 1;
  background-color: #f2f2f5;
}
.movie_swiper{
  .swiper-slide {
    width: 80%;
  }
}
.movie_list_0{
  width: calc(100% - 50px);
  margin: 0 auto;
}
.movie_cover{
  border-radius: 10px;
  width:550px;
  height:330px
}
.movie_list_0 .movie-list-item-bottom{
  position: relative;
  width: 550px;
  bottom: 43px;
}
.movie_list_0 .movie-list-item-bottom .movie-time-div{
  background-color: rgba(0,0,0,.4);
}
.movie_list_0 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
  font-size: 28px;
  color: #fff;
}
.movie_list_0 .movie-time-div {
  color: #fff;
  border-radius:  0 0 10px 10px;
}
.movie_list_0 .movie_swiper .hot{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}
.movie_list_0 span{
  font-size: 30px;
}
.movie_list_1{
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.movie_list_1 .movie-list-item .cover_img{
  border-radius: 10px;
  width:335px;
  height:290px;
}
.home-scroll{
  padding-bottom: 110px;
}
.movie_list_1 .movie-list-item{
  margin-bottom: -10px;
}

.movie_list_1 .movie-list-item-bottom{
  position: relative;
  width: 335px;
  bottom: 42px;

}
.movie_list_1 .movie-list-item:nth-child(odd){
  margin-right: 25px;
}
.movie_list_1 .movie-list-item-bottom .movie-time-div{
  background-color: rgba(0,0,0,.4);
}
.movie_list_1 .movie-list-item-bottom>div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
  color: #fff;
}
.movie_list_1 .movie-time-div {
  color: #fff;
  border-radius: 0 0 10px 10px;
  height: 35px;
}
.movie_list_1 .movie_swiper .hot{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 5px;
}

.movie_list_1 .movie-list-item .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 180px;
  padding-left: 8px;
  font-size: 25px;
}
.movie_list_1 .movie-list-item .movie-time-div span:last-child {
  overflow: hidden;
  white-space: nowrap;
  width: 0px;
  padding-right:110px;
  font-size: 22px;
}
.movie_list_0 .movie-time-div span:first-child {
  overflow: hidden;
  white-space: nowrap;
  width: 350px;
  padding-left: 10px;
  font-size: 25px;
}

</style>
